var map = {
	"./audio-placeholder": 680,
	"./audio-placeholder.png": 680,
	"./avatar-missing": 637,
	"./avatar-missing.png": 637,
	"./avatar-missing.svg": 816,
	"./halloween/clouds": 681,
	"./halloween/clouds.png": 681,
	"./halloween/halloween-emblem": 692,
	"./halloween/halloween-emblem.svg": 692,
	"./halloween/spider": 693,
	"./halloween/spider.svg": 693,
	"./halloween/spiderweb": 694,
	"./halloween/spiderweb.svg": 694,
	"./halloween/starfield": 695,
	"./halloween/starfield.png": 695,
	"./halloween/twinkle": 696,
	"./halloween/twinkle.svg": 696,
	"./header-missing": 642,
	"./header-missing.png": 642,
	"./soapbox-logo": 643,
	"./soapbox-logo-white": 644,
	"./soapbox-logo-white.svg": 644,
	"./soapbox-logo.svg": 643,
	"./sprite-post-functions": 697,
	"./sprite-post-functions.png": 697,
	"./video-placeholder": 698,
	"./video-placeholder.png": 698,
	"./void": 699,
	"./void.png": 699,
	"./web-push/web-push-icon_expand": 719,
	"./web-push/web-push-icon_expand.png": 719,
	"./web-push/web-push-icon_favourite": 720,
	"./web-push/web-push-icon_favourite.png": 720,
	"./web-push/web-push-icon_reblog": 721,
	"./web-push/web-push-icon_reblog.png": 721
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 815;